import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";

const ROWS = [
  { labelKey: "trade.conditions.r1.label", render: (t) => (
    <span className="font-['Inter'] font-normal text-[14px] xl:text-[14px] text-[#888] leading-normal">
      <span className="font-bold text-[#020202]">{t("trade.conditions.r1.bold")}</span>
      {t("trade.conditions.r1.rest")}
    </span>
  )},
  { labelKey: "trade.conditions.r2.label", render: (t) => (
    <span className="font-['Inter'] font-normal text-[14px] text-[#888] leading-normal">{t("trade.conditions.r2.text")}</span>
  )},
  { labelKey: "trade.conditions.r3.label", render: (t) => (
    <span className="font-['Inter'] font-normal text-[14px] text-[#888] leading-normal">
      {t("trade.conditions.r3.pre")}
      <span className="font-bold text-[#0a0a0a]">{t("trade.conditions.r3.bold")}</span>
    </span>
  )},
  { labelKey: "trade.conditions.r4.label", render: (t) => (
    <span className="font-['Inter'] font-normal text-[14px] text-[#888] leading-normal">
      <span className="font-bold text-[#0a0a0a]">{t("trade.conditions.r4.bold")}</span>
      {t("trade.conditions.r4.rest")}
    </span>
  )},
  { labelKey: "trade.conditions.r5.label", render: (t) => (
    <span className="font-['Inter'] font-normal text-[14px] text-[#888] leading-normal">{t("trade.conditions.r5.text")}</span>
  )},
  { labelKey: "trade.conditions.r6.label", render: (t) => (
    <span className="font-['Inter'] font-normal text-[14px] text-[#888] leading-normal">{t("trade.conditions.r6.text")}</span>
  )},
];

function Conditions() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col xl:flex-row xl:items-end gap-[40px] xl:gap-[103px]">

        {/* Left: text + CTA */}
        <div className="flex flex-col gap-[40px] xl:gap-0 xl:justify-between xl:h-[435px] xl:w-[517px] xl:shrink-0">
          <div className="flex flex-col gap-[20px] xl:gap-[40px]">
            <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
              {t("trade.conditions.title")}
            </h2>
            <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
              {t("trade.conditions.desc")}
            </p>
          </div>
          <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
        </div>

        {/* Right: table */}
        <div className="flex flex-col gap-[20px] xl:gap-[30px] flex-1">
          <h3 className="font-['Montserrat'] font-black text-[16px] xl:text-[24px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
            {t("trade.conditions.table.title")}
          </h3>
          <div className="h-[1px] bg-[#e5e5e5]" />
          <div className="flex flex-col gap-0">
            {ROWS.map((row, i) => (
              <div key={i} className={`flex gap-[20px] xl:gap-[40px] items-center py-[15px] xl:py-[17px] ${i % 2 === 0 ? "bg-[#ededed] px-[12px] xl:px-[20px] rounded-[2px]" : "px-[12px] xl:px-[20px]"}`}>
                <span className="font-['Montserrat'] font-extrabold text-[12px] xl:text-[14px] text-[#020202] tracking-[-0.17px] uppercase shrink-0 w-[90px] xl:w-[125px]">
                  {t(row.labelKey)}
                </span>
                <div className="flex-1">{row.render(t)}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default Conditions;
